var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enter",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M243.537,2.165A5.006,5.006,0,0,0,239.418,0h-53.75a15.018,15.018,0,0,0-15,15v3.895c.2.176.419.31.6.5l20,20a14.993,14.993,0,0,1,0,21.21l-20,20c-.185.185-.409.32-.6.5V90a15.018,15.018,0,0,0,15,15h17.5a4.991,4.991,0,0,0,4.67-3.22l36.25-95a4.992,4.992,0,0,0-.55-4.615Zm0,0",
    transform: "translate(-130.668)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M28.085,156.284A5.008,5.008,0,0,1,25,151.664v-15H5a5,5,0,0,1,0-10H25v-15a5,5,0,0,1,8.535-3.535l20,20a4.993,4.993,0,0,1,0,7.07l-20,20a5,5,0,0,1-5.45,1.085Zm0,0",
    transform: "translate(0 -81.664)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M335.482.548,305.443,10.563a10.049,10.049,0,0,0-6.775,9.489v90a10.01,10.01,0,0,0,10,10,10.49,10.49,0,0,0,3.185-.5l30.04-10.015a10.049,10.049,0,0,0,6.775-9.489v-90A10.067,10.067,0,0,0,335.482.548Zm0,0",
    transform: "translate(-228.668 -0.052)",
    fill: "#64b5f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.74ca1e894e4a5c2574d0286eb0de2622.svg";
export { ForwardRef as ReactComponent };